module.exports = function(video) {
	'use strict'
	video.directive('newVideoMediaoutcastDir',newVideoMediaoutcastDir);
	newVideoMediaoutcastDir.$inject=[];
	function newVideoMediaoutcastDir() {
		return {
			template: require('./partial/new-video-mediaoutcast.html'),
			controller:"newVideoMediaoutcastController",
			controllerAs:"vmnvm",
			link: function(scope, element, attrs, ctrl) {
				    
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/videoModule/new-video/js/directive/newVideoMediaoutcastDirective.js
// module id = 643
// module chunks = 0